import React, { useState } from 'react';
import { authService } from '../services/authService';

interface AlterarSenhaProps {
  onClose: () => void;
}

const AlterarSenha: React.FC<AlterarSenhaProps> = ({ onClose }) => {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState(false);
  const [carregando, setCarregando] = useState(false);
  
  const usuarioAtual = authService.getUsuario();
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Reset estados
    setErro(null);
    setSucesso(false);
    
    // Validações básicas
    if (!senhaAtual || !novaSenha || !confirmarSenha) {
      setErro('Por favor, preencha todos os campos');
      return;
    }
    
    if (novaSenha !== confirmarSenha) {
      setErro('As novas senhas não coincidem');
      return;
    }
    
    // Validação de força da senha
    if (novaSenha.length < 6) {
      setErro('A senha deve ter pelo menos 6 caracteres');
      return;
    }
    
    try {
      setCarregando(true);
      
      // Verificar se tem usuário logado
      if (!usuarioAtual || !usuarioAtual.id) {
        throw new Error('Usuário não encontrado');
      }
      
      await authService.alterarSenha(usuarioAtual.id, senhaAtual, novaSenha);
      setSucesso(true);
      
      // Limpar campos após sucesso
      setSenhaAtual('');
      setNovaSenha('');
      setConfirmarSenha('');
      
      // Fechar modal após 1.5 segundos
      setTimeout(() => {
        onClose();
      }, 1500);
      
    } catch (error) {
      if (error instanceof Error) {
        setErro(error.message);
      } else {
        setErro('Erro ao alterar senha');
      }
    } finally {
      setCarregando(false);
    }
  };
  
  return (
    <div 
      className="modal fade show" 
      style={{ 
        display: 'block', 
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999 
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          onClose();
        }
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-key mr-2"></i>
              Alterar Senha
            </h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          
          <div className="modal-body">
            {erro && (
              <div className="alert alert-danger">
                <i className="fas fa-exclamation-circle mr-2"></i>
                {erro}
              </div>
            )}
            
            {sucesso && (
              <div className="alert alert-success">
                <i className="fas fa-check-circle mr-2"></i>
                Senha alterada com sucesso!
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="senhaAtual">
                  <i className="fas fa-lock mr-2"></i>
                  Senha Atual
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="senhaAtual"
                  placeholder="Digite sua senha atual"
                  value={senhaAtual}
                  onChange={(e) => setSenhaAtual(e.target.value)}
                  disabled={carregando || sucesso}
                  autoFocus
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="novaSenha">
                  <i className="fas fa-key mr-2"></i>
                  Nova Senha
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="novaSenha"
                  placeholder="Digite sua nova senha"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  disabled={carregando || sucesso}
                />
                <small className="text-muted">
                  <i className="fas fa-info-circle mr-1"></i>
                  Mínimo de 6 caracteres
                </small>
              </div>
              
              <div className="form-group">
                <label htmlFor="confirmarSenha">
                  <i className="fas fa-shield-alt mr-2"></i>
                  Confirme a Nova Senha
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmarSenha"
                  placeholder="Confirme sua nova senha"
                  value={confirmarSenha}
                  onChange={(e) => setConfirmarSenha(e.target.value)}
                  disabled={carregando || sucesso}
                />
              </div>
              
              <div className="modal-footer px-0 pb-0">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={onClose} 
                  disabled={carregando}
                >
                  <i className="fas fa-times mr-2"></i>
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary" 
                  disabled={carregando || sucesso}
                >
                  {carregando ? (
                    <>
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Processando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save mr-2"></i>
                      Alterar Senha
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlterarSenha;
